/**
 * @file   src\store\actions\settingsAction.ts
 * @brief  This file is responsible for creating asynchronous company settings based api call.
 * @date   JULY, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { SettingsApi } from '../../utils/apiUrls';
import axios from '../../config/axiosConfig';
import { ISettingsAPIRequest } from 'src/interfaces/settingsInterface';
import { ILocaleMeta } from 'src/interfaces/localeInterface';
import { setLocalStorage, getFromLocalStorage } from '../../utils/helper';
import { setActiveLocale, buildPublicLocaleMeta } from '../../utils/countryHelper';

// Get company settings api
export const getCompanySettings = createAsyncThunk('/settings/getCompanySettings', async (request: ISettingsAPIRequest, { rejectWithValue }) => {
  try {
    let param = '';
    param += request.carwashname;
    const { data } = await axios.get(SettingsApi.GET_SETTINGS+param);
    if(data?.error === 0) {
        const localeMeta: ILocaleMeta = buildPublicLocaleMeta(
          data.data?.countryCode,
          data.data?.currency,
          data.data?.locale,
          data.data?.timezone,
        );
        const settingsPayload = { ...data.data, ...localeMeta };
        setLocalStorage('CARWASH_COMPANY_SETTINGS_DATA',JSON.stringify(settingsPayload));
        setActiveLocale(localeMeta);
        setLocalStorage('LOGO_URL_SETTINGS_DATA',JSON.stringify(data.data.logoFile));
        setLocalStorage('carWashId',data?.data?.carWashID)
        // get from local storage
        const settings = getFromLocalStorage('CARWASH_COMPANY_SETTINGS_DATA') || {};
        const parsedTheme = settings?.appTheme ? JSON.parse(settings.appTheme) : {};
        const IsCustom = settings?.IsCustom === 1 ? 1 : 0;
      // Define your color constants
      const PRIMARY_COLOR = IsCustom ? parsedTheme?.primary :'#0182F0';
      const SECONDARY_COLOR = IsCustom ? parsedTheme.secondary :'#172951';
      const BUTTON_PRIMARY_COLOR = IsCustom ? parsedTheme.btn_primary : '#FFD500';
      const BUTTON_TEXT_COLOR = IsCustom ? parsedTheme.btn_secondary : '#172951';
      const TEXT_PRIMARY_COLOR = IsCustom ? parsedTheme.text_primary : '#000000';

      // Function to set CSS variables
      const setCSSVariables = () => {
          document.documentElement.style.setProperty('--PrimaryColor', PRIMARY_COLOR);
          document.documentElement.style.setProperty('--SecondaryColor', SECONDARY_COLOR);
          document.documentElement.style.setProperty('--ButtonPrimaryColor', BUTTON_PRIMARY_COLOR);
          document.documentElement.style.setProperty('--ButtonTextColor', BUTTON_TEXT_COLOR);
          document.documentElement.style.setProperty('--TextPrimaryColor', TEXT_PRIMARY_COLOR);
      };

        // Call the function to set the variables when the app initializes
      setCSSVariables();
    }

    return data;
  } catch (error: any) {
    return rejectWithValue(error.data);
  }
});
